import {auth} from "../../../Auth"

export default function permissions () {
  if (auth && auth.sunkaizenUser) { return [{terms: {organizations: [auth.sunkaizenUser.id]}}] }
  else return
}